export const aimoParkingCompanyStatus = (value: string | null) => {
  return value ? "削除済み" : "-";
};
